export default {"src":"/_next/static/media/dog_40.2d72e1f0.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};